import BaseLayout from '../base/BaseLayout/BaseLayout';
import { FC, Children, isValidElement } from 'react';
import { LayoutProps } from '../types/layout.types';

const SnowLayout: FC<LayoutProps> = ({ children, navigation, footer }) => {
  const contentElements = Children.toArray(children);

  const layoutContent: {
    displayContent: JSX.Element;
    colorTheme: string;
  }[] = [];

  contentElements.forEach((ce) => {
    if (isValidElement(ce)) {
      const props = {
        displayContent: ce,
        colorTheme: 'snow',
      };
      layoutContent.push(props);
    }
  });

  return (
    <BaseLayout
      layoutContent={layoutContent}
      navigation={navigation}
      footer={footer}
    />
  );
};

export default SnowLayout;
